<template lang="html">
  <div class="province-F">
    <!-- <div class="ttBar">
      <span>出版经营情况统计</span>
      getPublicationStatisticList
    </div> -->
    <div class="tabArea">
      <div class="seekArea">
        <div class="selectBox">
          <span>资质：</span>
          <el-select v-model="selType" size="small" placeholder="请选择" style="width: 80px">
            <el-option v-for="item in Zizhi" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span>省局：</span>
          <el-select v-model="selProvinceId" size="small" placeholder="请选择" clearable style="width: 230px">
            <el-option
              v-for="item in Shengju"
              :key="item.sjExamineId"
              :label="item.sjExamine"
              :value="item.sjExamineId">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="selectBox">
          <span>排序：
          </span>
          <el-select v-model="selOrder" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for="item in OrderBy" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="selSort" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for=" item in Sort" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div> -->
        <div class="selectBox">
          <span>年份：</span>
          <el-select v-model="selYear" size="small" placeholder="历年记录" style="width: 120px">
            <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <el-button size="small" type="primary" @click="goSeek" :loading="loading">搜索</el-button>
          <el-button size="small" type="primary" plain style="margin-left: 10px" @click="goExport">导出</el-button>
        </div>
      </div>
      <el-table :data="tabDats" style="width: 100%" border :height="this.tableHeight">
        <el-table-column prop="organizationName" label="出版单位" width="180" fixed> </el-table-column>
        <el-table-column prop="provinceName" label="所属省局" width="180"> </el-table-column>
        <el-table-column prop="type" label="资质" width="180"> </el-table-column>
        <el-table-column prop="nature" label="企业性质" width="180"> </el-table-column>
        <el-table-column prop="isIndependentLP" label="是否为独立法人" width="180"> </el-table-column>
        <el-table-column prop="LPSituation" label="隶属关系" width="180"> </el-table-column>
        <el-table-column prop="hostName" label="主办单位" width="180"> </el-table-column>
        <el-table-column prop="chargeName" label="主管单位" width="180"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getProviceList, getBasicInfoStatisticList } from "@/api/adminRole/adminRole";
import { getSelYearRecord } from "@/api/pressRole/pressRole";
import { outExcel } from "@/utils/Export";

export default {
  data() {
    return {
      selYear: "",
      selYearRecord: [],
      loading: false,

      selType: "1",
      Zizhi: [
        {
          value: "1",
          label: "音像",
        },
        {
          value: "2",
          label: "电子",
        },
      ],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [
        {
          value: "firstTotalSales",
          label: this.selYear + "年销售收入",
        },
        {
          value: "firstTotalProfit",
          label: this.selYear + "年利润总额",
        },
        {
          value: "firstSales",
          label: this.selYear + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "销售收入",
        },
        {
          value: "firstProfit",
          label: this.selYear + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "利润总额",
        },
        {
          value: "firstPublicationVariety",
          label: this.selYear + "年出版品种数量",
        },
        {
          value: "secondTotalSales",
          label: this.selYear * 1 + 1 + "年销售收入",
        },
        {
          value: "secondTotalProfit",
          label: this.selYear * 1 + 1 + "年利润总额",
        },
        {
          value: "secondSales",
          label: this.selYear * 1 + 1 + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "销售收入",
        },
        {
          value: "secondProfit",
          label: this.selYear * 1 + 1 + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "利润总额",
        },
        {
          value: "secondPublicationVariety",
          label: this.selYear * 1 + 1 + "年出版品种数量",
        },
      ],

      selSort: "asc",
      Sort: [
        {
          value: "asc",
          label: "正序",
        },
        {
          value: "desc",
          label: "倒序",
        },
      ],

      tabDats: [],
      params: {
        year1: "",
      },

      dicDats: [],
      dicMap: {},

      tableHeight: 250,
    };
  },

  methods: {
    tabSeek: async function (type) {
      this.loading = true;
      this.params = {
        type: this.selType,
        provinceId: this.selProvinceId,
        order: this.selOrder,
        sort: this.selSort,
        year: this.selYear,
      };
      let vm = this;

      getBasicInfoStatisticList(this.params).then((response) => {
        console.debug("getBasicInfoStatisticList: ", response);
        console.debug("数据字典: ", vm.$store.getters.dictionary);
        for (var i in response.basicInfoStatisticList) {
          // 资质
          response.basicInfoStatisticList[i].type = response.basicInfoStatisticList[i].type == 1 ? "音像" : "电子";
          // 企业性质
          response.basicInfoStatisticList[i].nature = this.dicMap["C001"][response.basicInfoStatisticList[i].nature];
          // 隶属关系
          response.basicInfoStatisticList[i].isIndependentLP =
            this.dicMap["C018"][response.basicInfoStatisticList[i].isIndependentLP];
          var LPSituation = "";
          if (
            response.basicInfoStatisticList[i].independentLPSituation &&
            response.basicInfoStatisticList[i].independentLPSituation.length > 0
          ) {
            LPSituation = this.dicMap["C003"][response.basicInfoStatisticList[i].independentLPSituation];
          }
          if (
            response.basicInfoStatisticList[i].nonIndependentLPSituation &&
            response.basicInfoStatisticList[i].nonIndependentLPSituation.length > 0
          ) {
            LPSituation = this.dicMap["C004"][response.basicInfoStatisticList[i].nonIndependentLPSituation];
          }
          response.basicInfoStatisticList[i].LPSituation = LPSituation;
        }

        setTimeout(function () {
          vm.loading = false;
          vm.tabDats = response.basicInfoStatisticList;
        }, 300);
      });
    },
    dictInit: function () {
      let nameArr = ["C018", "C003", "C004", "C001"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });

      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C018"] = this.$store.getters.dictionary["C018"];
        this.dicMap["C003"] = this.$store.getters.dictionary["C003"];
        this.dicMap["C004"] = this.$store.getters.dictionary["C004"];
        this.dicMap["C001"] = this.$store.getters.dictionary["C001"];
      });
    },

    goFirm: function (rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear,
        },
      });
    },
    pageSent: function (inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function () {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.loading = true;
      this.tabSeek();
    },
    provinceSet: function () {
      let vm = this;
      getProviceList({
        type: this.selType,
      }).then((response) => {
        vm.Shengju = response.proList;
      });
    },
    getOrderByList: function (year, type) {
      return [
        {
          value: "firstTotalSales",
          label: year + "年销售收入",
        },
        {
          value: "firstTotalProfit",
          label: year + "年利润总额",
        },
        {
          value: "firstSales",
          label: year + "年" + (type == 1 ? "音像制品" : "电子出版物") + "销售收入",
        },
        {
          value: "firstProfit",
          label: year + "年" + (type == 1 ? "音像制品" : "电子出版物") + "利润总额",
        },
        {
          value: "firstPublicationVariety",
          label: year + "年出版品种数量",
        },
        {
          value: "secondTotalSales",
          label: year * 1 + 1 + "年销售收入",
        },
        {
          value: "secondTotalProfit",
          label: year * 1 + 1 + "年利润总额",
        },
        {
          value: "secondSales",
          label: year * 1 + 1 + "年" + (type == 1 ? "音像制品" : "电子出版物") + "销售收入",
        },
        {
          value: "secondProfit",
          label: year * 1 + 1 + "年" + (type == 1 ? "音像制品" : "电子出版物") + "利润总额",
        },
        {
          value: "secondPublicationVariety",
          label: year * 1 + 1 + "年出版品种数量",
        },
      ];
    },
    getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },
    goExport: function () {
      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear,
      };
      getBasicInfoStatisticList(params).then((response) => {
        console.debug("getBasicInfoStatisticList: ", response);
        for (var i in response.basicInfoStatisticList) {
          // 资质
          response.basicInfoStatisticList[i].type = response.basicInfoStatisticList[i].type == 1 ? "音像" : "电子";
          // 企业性质
          response.basicInfoStatisticList[i].nature = that.dicMap["C001"][response.basicInfoStatisticList[i].nature];
          // 隶属关系
          response.basicInfoStatisticList[i].isIndependentLP =
            that.dicMap["C018"][response.basicInfoStatisticList[i].isIndependentLP];
          var LPSituation = "";
          if (
            response.basicInfoStatisticList[i].independentLPSituation &&
            response.basicInfoStatisticList[i].independentLPSituation.length > 0
          ) {
            LPSituation = that.dicMap["C003"][response.basicInfoStatisticList[i].independentLPSituation];
          }
          if (
            response.basicInfoStatisticList[i].nonIndependentLPSituation &&
            response.basicInfoStatisticList[i].nonIndependentLPSituation.length > 0
          ) {
            LPSituation = that.dicMap["C004"][response.basicInfoStatisticList[i].nonIndependentLPSituation];
          }
          response.basicInfoStatisticList[i].LPSituation = LPSituation;
        }

        var filename = "基本信息情况统计";
        var cols = [
          {
            dataIndex: "organizationName",
            title: "出版单位",
            width: 180,
          },
          {
            dataIndex: "provinceName",
            title: "所属省局",
            width: 180,
          },
          {
            dataIndex: "type",
            title: "资质",
            width: 180,
          },
          {
            dataIndex: "nature",
            title: "企业性质",
            width: 180,
          },
          {
            dataIndex: "LPSituation",
            title: "隶属关系",
            width: 180,
          },
          {
            dataIndex: "hostName",
            title: "主办单位",
            width: 180,
          },
          {
            dataIndex: "chargeName",
            title: "主管单位",
            width: 180,
          },
        ];
        var wsname = "基本信息情况统计";
        outExcel(response.basicInfoStatisticList, cols, filename, wsname);
      });
    },
  },

  created: function () {
    this.provinceSet();
    this.dictInit();
    let that = this;
    getSelYearRecord({
      publishId: "",
      type: 3,
    }).then((response) => {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            that.params.year1 = po.firstYear;
            that.selYear = po.firstYear;

            that.OrderBy = that.getOrderByList(that.selYear, that.selType);
          }
        }
      }
      that.selYearRecord = arr;
      // that.tabSeek();
    });
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function () {
    this.$nextTick(() => {
      this.getHeight();
    });
  },
  destroyed: function () {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 12px;

    .seekArea {
      margin-bottom: 12px;
      overflow: hidden;
      .selectBox {
        padding-left: 10px;
        float: left;
      }
      .el-input {
        input {
          border-radius: 0px;
        }
      }
    }

    .pageCage {
      text-align: center;
      margin: 30px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// adminBasicOperation.vue?5e84f7f2